import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from '../../../../helpers/Promise';
import PageTitle from './components/PageTitle';
import StatusMessageConsumer from './components/StatusMessageConsumer';
import ComponentLoader from '../../../ComponentLoader';

export default function PageContent({ title, description, loading, loadingMessage, children }) {
  if (isFunction(children)) {
    return children({ PageTitle, StatusMessageConsumer });
  }

  return (
    <>
      <StatusMessageConsumer />
      <ComponentLoader loading={loading} message={loadingMessage}>
        <PageTitle title={title} description={description} />
        {children}
      </ComponentLoader>
    </>
  );
}

PageContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
  loadingMessage: PropTypes.string,
};

PageContent.defaultProps = {
  title: undefined,
  description: undefined,
  children: null,
  loading: false,
  loadingMessage: undefined,
};
